
export { fetchServerXAuthWithBinaryRole } from "/builds/t2_e_sw-P/2/dd3tech/wiggot/wiggot-web/packages/utils/src/fetch-server.ts"